module.exports = __webpack_public_path__ + "img/awards_04.c52ca030.jpg";